import ImageElement from '@/components/ImageElement'

export default {
  components: {
    ImageElement
  },
  props: {
    cardText: Object
  },
  computed: {
    imageData() {
      return {
        src: this.cardText.imageBg,
        alt: this.cardText.imageBg
      }
    }
  },
  methods: {
    imageDataScroll(cardText) {
      return {
        src: cardText.imageBg,
        alt: cardText.imageBg
      }
    }
  }
}